import { render, staticRenderFns } from "./FormNumber.vue?vue&type=template&id=2dcd35e9"
import script from "./FormNumber.vue?vue&type=script&lang=js"
export * from "./FormNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports